<template lang="pug">
.container
    nav.nav
        router-link.button__action(
            to="/media-libraries/"
            active-class="null"
        )
            i.glyphicon.glyphicon-chevron-left.icon
            | Go back
        .submit__container
            div.locales()
                span(
                v-if="getActiveMediaLibrary.localRecords && getActiveMediaLibrary.localRecords.length > 1"
                ) Switching locales will clear unsaved changes.
                //- span Editing Locale:
                button.button(
                :disabled="localRecord=== getActiveLocale"
                v-for="localRecord in getSortedAvailableLocales"
                value="localRecord"
                @click="changeLocale(localRecord)"
                ) {{localRecord}}
            button.button__submit(
                type="button"
                @click="save()"
            ) Save
            button.button__action(
                @click="toggleAddLocale"
            ) Add Locale
    .editing__container
        .content__container
            h1 Edit Media Library
            .form__control-group
                label Name
                input(
                    class="input__text title"
                    type="text"
                    v-model="getActiveLocalRecord.title"
                )
        .meta__container
            h1 &nbsp;
            .form__control-group
                label Markets
                multiselect(
                    v-model="getSortedAvailableLocales"
                    :options="getMarketsByLocale"
                    placeholder="Add a Market"
                    :multiple="true"
                )
</template>
<script>
import store from '../../store';
import VueNotifications from 'vue-notifications';
import Services from '../../services/Services';
import Multiselect from 'vue-multiselect';
import { postResource } from '../../services/Utils';
import moment from 'moment';
export default {
  name: 'MediaLibraryEditor',
  components: {
    Multiselect
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data() {
    return {};
  },
  computed: {
    getActiveMediaLibrary: {
      get: function() {
        return store.getters.getActiveMediaLibrary;
      },
      set: function(mediaLibrary) {
        store.commit('setActiveMediaLibrary', mediaLibrary);
      }
    },
    getActiveLocale() {
      return store.getters.getActiveLocale;
    },
    getActiveLocalRecord: {
      get: function() {
        return store.getters.getActiveLocalRecord;
      },
      set: function(record) {
        store.commit('setActiveLocalRecord', record);
      }
    },
    getMarkets() {
      return store.getters.getMarkets;
    },
    getSortedAvailableLocales: {
      get: function() {
        if (
          this.getActiveMediaLibrary &&
          this.getActiveMediaLibrary.localRecords
        ) {
          let locales = [];

          this.getActiveMediaLibrary.localRecords.forEach(locale => {
            locales.push(locale.locale);
          });

          return locales.sort((a, b) => a.name - b.name).reverse();
        }
      },
      set: function(newLocales) {
        let activeMediaLibrary = { ...this.getActiveMediaLibrary };
        activeMediaLibrary.markets = newLocales;
        store.commit('setActiveMediaLibrary', activeMediaLibrary);
        if (
          activeMediaLibrary.localRecords &&
          newLocales.length > activeMediaLibrary.localRecords.length
        ) {
          store.commit('showCreateMediaLibraryLocalRecordModal', true);
        }
      }
    },
    getMarketsByLocale() {
      if (this.getMarkets) {
        let marketsByLocale = [];

        this.getMarkets.forEach(market => {
          marketsByLocale.push(market.locale);
        });

        return marketsByLocale;
      }
    }
  },
  methods: {
    initializeMediaLibrary(edited) {
      const mediaLibrary = this.getActiveMediaLibrary;

      if (!mediaLibrary._id) {
        this.showErrorMsg({ message: 'No matching media library found' });
        this.$router.push('/media-libraries/');
      }

      this.setActiveLocalContent();
    },
    setActiveLocalRecord(locale) {
      if (!locale) {
        const defaultLocale = this.getActiveMediaLibrary.localRecords
          ? this.getActiveMediaLibrary.localRecords[0].locale
          : '';
        store.commit('setActiveLocale', defaultLocale);
      } else {
        store.commit('setActiveLocale', locale);
      }

      //   this.setActiveLocalContent();
    },
    setActiveLocalContent() {
      if (
        this.getActiveMediaLibrary.localRecords &&
        this.getActiveMediaLibrary.localRecords.length &&
        this.getActiveLocale
      ) {
        const activeContent =
          this.getActiveMediaLibrary.localRecords.filter(record => {
            return record.locale === this.getActiveLocale;
          })[0].content || {};
        if (!activeContent.title) {
          activeContent.title = '';
        }
        return store.commit('setActiveLocalRecord', activeContent);
      } else if (
        this.getActiveMediaLibrary.localRecords &&
        this.getActiveMediaLibrary.localRecords.length
      ) {
        const activeContent = this.getActiveMediaLibrary.localRecords[0]
          .content;
        return store.commit('setActiveLocalRecord', activeContent);
      } else {
        this.getActiveLocalRecord = {
          title: ''
        };
      }
    },
    changeLocale(locale) {
      store.commit('setActiveLocale', locale);
      this.setActiveLocalContent();
      this.initializeMediaLibrary(true);
    },
    toggleAddLocale() {
      store.commit('showCreateMediaLibraryLocalRecordModal', true);
    },
    save() {
      const update = this.getActiveMediaLibrary;
      const contentUpdate = this.getActiveLocalRecord;
      update.content = contentUpdate;
      postResource(
        '/v1/medialibraries/update',
        `id=${this.getActiveMediaLibrary._id}&locale=${encodeURIComponent(
          this.getActiveLocale
        )}`,
        update
      )
        .then(res => {
          this.showSuccessMsg({
            message: `${this.getActiveLocale} media library saved!`
          });
        })
        .catch(error => {
          this.showSuccessMsg({
            message: `${this.getActiveLocale} media library saved!`
          });
        });
    }
  },
  mounted() {
    const mediaLibraryId = this.$route.params.mediaLibraryId;

    if (!mediaLibraryId) {
      this.showErrorMsg({ message: 'No matching media library found' });
      this.$router.push('/media-libraries/');
    }

    Services.setActiveMediaLibrary(
      mediaLibraryId,
      this.initializeMediaLibrary(false)
    );

    // this.setActiveLocalRecord();
    if (!store.getters.getMarkets.length) {
      Services.getMarkets();
    }
  },
  updated() {
    if (!this.getActiveLocale) {
      this.setActiveLocalRecord();
      this.setActiveLocalContent();
    }
  },
  beforeDestroy() {
    store.commit('setActiveLocale', null);
    Services.clearActiveProduct();
    Services.clearActiveRecords();
  }
};
</script>
<style lang="scss" scoped>
.button__submit {
  padding: 8px 32px;
  width: auto;
  margin-left: 25px;
}

.editing__container {
  display: flex;
  padding: 2rem;
  margin-top: 2rem;
  flex-wrap: no-wrap;
  width: 100%;

  .form__control-group {
    margin-bottom: 0.625rem;
  }

  input,
  textarea {
    width: 100%;

    &.title {
      max-width: 630px;
    }
  }

  .image__container,
  .meta__container {
    width: 33.33%;

    .button__action {
      margin: 1rem 0;
    }
  }

  .image__container {
    display: block;

    img {
      margin: auto;
    }
  }

  .content__container {
    width: 100%;
  }

  .content__container,
  .meta__container {
    padding-left: 2.6rem;
  }

  @media all and (max-width: 640px) {
    flex-direction: column;

    .image__container,
    .content__container,
    .meta__container {
      padding-left: 0;
      width: 100%;
    }
  }
}

.form__control-group {
  label {
    display: block;
    margin-bottom: 5px;
  }

  .product-image {
    margin-top: 1.6rem;
    max-width: 630px;
    width: 100%;
  }
}

.media__container,
.product__container {
  padding-left: 4.7rem;
  margin-bottom: 2rem;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/views/MediaLibraryEditor.vue